export enum DropDataType {
    OBJET_MAQUETTE,
    PIA
}

export interface DropData {
    type: DropDataType;
    // valorisé uniquement si type = OBJET_MAQUETTE
    objetMaquetteId?: string;
    objetMaquettePath?: string;
}
